<template>
  <g 
    :transform="transform"
    @click="click"
    @mousemove="hover"
    @mouseleave="hoverend"
    @mousedown="dragstart"
    :style="style"
  >
    <linearGradient
      v-if="domId"
      :id="domId"
      :x1="gradient.x1" :x2="gradient.x2" :y1="gradient.y1" :y2="gradient.y2"
    >
      <stop offset="0%" :stop-color="onColor"/>
      <stop :offset="onGrad" :stop-color="onColor"/>
      <stop :offset="offGrad" :stop-color="offColor"/>
      <stop offset="100%" :stop-color="offColor"/>
    </linearGradient>
    <hexagon
      v-if="curve === 1"
      :fill="fill"
      :stroke="fill"
      :stroke-width="strokeWidth"
      class="hc-hexagon"
    />
    <hexagon-path
      v-if="curve < 1"
      :fill="fill"
      :stroke="fill"
      :stroke-width="strokeWidth"
      :curve="curve"
      class="hc-hexagon"
    />
    <text-in-a-box
      v-if="text || textValue"
      :text="text"
      :bbox="bbox"
      :textValue="textValue"
      class="hc-text-in-a-box"
    />
  </g>
</template>

<script>
import TextInABox from './TextInABox'
import Hexagon from '../shapes/Hexagon'
import HexagonPath from '../shapes/HexagonPath'
export default {
  name: 'Complexagon',
  components: {
    TextInABox,
    Hexagon,
    HexagonPath
  },
  props: {
    // Main bindings
    id: {
      type: Number,
      default: 0
    },
    groupId: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    },
    hasChildren : {
      type: Boolean,
      default: false
    },
    isDraggable : {
      type: Boolean,
      default: false
    },
    // Style
    curve: {
      type: Number,
      default: 1
    },
    onColor: {
      type: String,
      default: '#f56043'
    },
    offColor: {
      type: String,
      default: '#757575'
    },
    strokeWidth: {
      type: Number,
      default: 1
    },
    gradient: {
      type: Object,
      default: function () {
        return {
          x1: 0,
          x2: 1,
          y1: 0,
          y2: 0
        }
      }
    },
    gradientSpread: {
      type: Number,
      default: .5
    },
    // Geometry
    x: {
      type: Number,
      default: 0
    },
    y: {
      type: Number,
      default: 0
    },
    scale: {
      type: Number,
      default: 1
    },
    angle: {
      type: Number,
      default: 0
    },
    // Content
    text: {
      type: String,
      default: ''
    },
    textValue: {
      type: String,
      default: ''
    },
    bbox: {
      type: Array,
      default () { return [0, 0, 1, 1] }
    }
  },
  data () {
    return {
      dragging: false,
      clickReady: true,
      cooldown: setTimeout(() => null, 0),
      dragX: 0,
      dragY: 0
    }
  },
  mounted () {
    window.addEventListener('mousemove', this.drag)
    window.addEventListener('mouseup', this.dragend)
  },
  methods: {
    click (e) {
      if (this.clickReady) {
        this.$emit('hc-click', e, this.id, this.groupId)
      }
    },
    hover (e) {
      if (!this.dragging) {
        this.$emit('hc-hover', e, this.id, this.groupId)
      }
    },
    hoverend (e) {
      if (!this.dragging) {
        this.$emit('hc-hoverend', e, this.id, this.groupId)
      }
    },
    dragstart (e) {
      this.dragging = !this.dragging
      this.$emit('hc-dragstart', e)
      this.dragX = e.clientX - this.x
      this.dragY = e.clientY - this.y
    },
    dragend (e) {
      this.dragging = false
      this.$emit('hc-dragend', e)
    },
    drag (e) {
      if (this.dragging) {
        this.clickReady = false
        e.stopImmediatePropagation()
        e.dragX = e.clientX - this.dragX
        e.dragY = e.clientY - this.dragY
        this.$emit('hc-drag', e, this.id, this.groupId)
      }
    }
  },
  watch: {
    dragging (nowdrag, wasdrag) {
      if (!nowdrag && wasdrag) {
        clearTimeout(this.cooldown)
        return this.cooldown = setTimeout(() => {
          this.clickReady = true
        }, 500)
      }
    }
  },
  computed: {
    transform () {
      return `translate(${this.x} ${this.y}) scale(${this.scale}) rotate(${this.angle})`
    },
    fill () {
      if (this.value === 1) {
        return this.onColor
      }
      if (this.value === 0) {
        return this.offColor
      }
      return `url(#hc-hexa-grad${this.id || this._uid})`
    },
    domId () {
      if (this.value !== 1 && this.value !== 0) {
        return `hc-hexa-grad${this.id || this._uid}`
      }
      return false
    },
    offGrad () {
      return `${(this.value + this.value * this.gradientSpread) * 100}%`
    },
    onGrad () {
      return `${(this.value - this.value * this.gradientSpread) * 100}%`
    },
    style () {
      return { cursor: (this.clickReady && this.hasChildren) ? 'pointer' : this.isDraggable ? (this.dragging ? 'grabbing' : 'grab') : '' }
    }
  },
  beforeDestroy () {
    window.removeEventListener('mousemove', this.drag)
    window.removeEventListener('mouseup', this.dragend)
  }
}
</script>

<style>

</style>
